<template>
  <div
    class="container float-container"
    v-bind:class="{ active: value || focused }"
  >
    <label :for="'text-' + _uid" :class="{ error: _error }">{{ label }}</label>
    <input
      ref="input"
      :id="'text-' + _uid"
      :name="'text-' + _uid"
      type="search"
      :placeholder="cHint"
      :value="value"
      :class="{ error: _error, disabled: disabled }"
      :pattern="pattern"
      :inputmode="inputmode"
      :maxlength="maxlength"
      :disabled="disabled"
      v-on:keypress="filter($event)"
      :data-obfuscate="quantumObfuscate"
      @blur="onBlur"
      @focus="onFocus"
      @input="onInput"
      @click="$emit('click')"
    />
    <span class="error" v-if="_error">
      <img src="@/assets/img/1x/error_icon.png" alt="Ícono error" />
      <p>{{ _error }}</p>
    </span>
    <span v-if="!_error && subhint" class="subhint">
      <p>{{ subhint }}</p>
    </span>
  </div>
</template>

<script>
export default {
  name: "text-input",
  props: {
    hint: String,
    label: String,
    value: String,
    required: Boolean,
    name: String,
    pattern: String,
    inputmode: String,
    maxlength: String,
    subhint: String,
    validationError: String,
    disabled: {
      type: Boolean,
      default: false
    },
    scrollOnFocus: {
      type: Boolean,
      default: true
    },
    maxlengthError: {
      type: Number,
      default: 0
    },
    reportGTMBlur: {
      type: Boolean,
      default: true
    },
    analyticsName: {
      type: String,
      default: null
    },
    analyticsTypology: {
      type: String,
      default: null
    },
    analyticsSubmodule: {
      type: String,
      default: null
    },
    quantumObfuscate: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      tmpHint: "",
      actualHint: this.hint,
      focused: false
    };
  },
  replace: false,
  computed: {
    cHint() {
      return this.tmpHint;
    },
    error() {
      if (this.validCheck && !this.isValid() && this._isVoid()) {
        return "Tenés que ingresar este dato";
      } else if (
        this.validCheck &&
        !this.isValid() &&
        !this._isMaxLengthValid()
      ) {
        return `Ingresá menos de ${this.maxlengthError} caracteres`;
      } else if (this.validCheck && !this.isValid()) {
        return "El valor ingresado es incorrecto";
      }
      return null;
    },
    _error() {
      /**
       * Verificar si el componente padre
       * pasó un error de validación por props
       * si no --> usar el error interno
       */
      if (this.validationError) {
        return this.validationError;
      }
      return this.error;
    }
  },
  methods: {
    /* Si bien se usa Pattern y NumericInput, al no utilizar type="number" deja ingresar texto
    Pero si le pongo type="numeric", Me deja de funcionar el boton de clear de type="search", con lo cual
    tengo que filtrar el ingreso... bsternari */
    filter(evt) {
      if (this.inputmode !== "numeric") {
        return true;
      }

      let charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    onInput(e) {
      // Función para reemplazar caracteres acentuados
      let stripAccents = (function() {
        let in_chrs = "àáâãäçèéêëìíîïñòóôõöùúûüýÿÀÁÂÃÄÇÈÉÊËÌÍÎÏÑÒÓÔÕÖÙÚÛÜÝ",
          out_chrs = "aaaaaceeeeiiiinooooouuuuyyAAAAACEEEEIIIINOOOOOUUUUY",
          chars_rgx = new RegExp("[" + in_chrs + "]", "g"),
          transl = {},
          i,
          lookup = m => transl[m] || m;

        for (i = 0; i < in_chrs.length; i++) {
          transl[in_chrs[i]] = out_chrs[i];
        }

        return s => s.replace(chars_rgx, lookup);
      })();

      // No permitir caracteres acentuados
      e.target.value = stripAccents(e.target.value);
      this.$emit("input", e.target.value);
    },
    onBlur() {
      this.focused = false;
      this.tmpHint = "";
      this.$emit("onBlur");
    },
    onFocus() {
      this.focused = true;
      this.$emit("onFocus");
      setTimeout(() => (this.tmpHint = this.actualHint), 180);
      /* Animar viewport para que el elemento quede arriba
      70 = alto de topbar + padding */
      if (this.scrollOnFocus) {
        window.scroll({
          top: this.$el.offsetTop - 70,
          left: 0,
          behavior: "smooth"
        });
      }
    },
    _focus() {
      /* Forzar el foco en el elemento
      método útil para que usen elementos padres */
      this.$refs.input.focus();
    },
    _isVoid() {
      return !!(!this.value || this.value.trim() === "");
    },
    _isMaxLengthValid() {
      if (this.maxlengthError) {
        return this.value.length <= this.maxlengthError;
      }
      return true;
    },
    isValid() {
      if (this.required) {
        const characterRegex = new RegExp(this.pattern);
        return (
          !this._isVoid() &&
          this._isMaxLengthValid() &&
          characterRegex.test(this.value.trim())
        );
      }
      return true;
    }
  }
};
</script>

<style scoped>
input {
  /* Dar un poco de espacio para "centrar" el texto verticalmente */
  border-top: 17px solid transparent;
}

div.float-container {
  position: relative;
}

label {
  font-size: 15px;
  color: #666;
  font-family: "BentonSansBBVA-Book", Helvetica, Arial, sans-serif;
  position: absolute;
  -webkit-transform-origin: top left;
  transform-origin: top left;
  -webkit-transform: translate(16px, 19px) scale(1);
  transform: translate(16px, 19px) scale(1);
  transition: all 0.3s ease-in-out;
}
div.float-container.active label {
  -webkit-transform: translate(16px, 8px) scale(0.75);
  transform: translate(16px, 8px) scale(0.75);
}

/* Estilos Disabled */
input.disabled {
  pointer-events: none;
  opacity: 0.5;
}

/* Estilos para errores */
input.error {
  background: #fcdfdf;
}

label.error {
  color: #b92a45;
}

span.error {
  margin-left: 16px;
  margin-top: 8px;
  display: block;
}

span > img,
span > p {
  display: inline-block;
  vertical-align: top;
}

span > img {
  width: 16px;
}

span > p {
  margin-left: 2px;
  margin-top: 0px;
  margin-bottom: 0px;
  font-family: "BentonSansBBVA-Light", Helvetica, Arial, sans-serif;
  font-size: 12px;
  line-height: 1.33;
  color: #121212;
}

/* Subhint */
span.subhint {
  display: block;
  padding-top: 5px;
}
</style>
